import { z } from 'zod'

// Constants
export const COMPONENTS = [
  { value: '', label: '' },
  { value: 'actual', label: 'Actual' },
  { value: 'target', label: 'Target' },
  { value: 'percent', label: 'Percent' },
  { value: 'score', label: 'Score' },
]

export const STATISTIC = [
  { value: '', label: '' },
  { value: 'value', label: 'Value' },
  { value: 'value_ytd', label: 'Value YTD' },
  { value: 'rank', label: 'Rank' },
  { value: 'team_rank', label: 'Team Rank' },
]

// SimpleBox Options
export const SimpleBoxOptions = z.object({
  title: z.string().default(''),
  metric: z.string().default(''),
  component: z
    .enum(['', 'actual', 'target', 'percent', 'score'])
    .default('actual'),
  statistic: z
    .enum(['', 'value', 'value_ytd', 'rank', 'team_rank'])
    .default('value'),
  format: z
    .enum(['default', 'ordinal', 'currency', 'percent'])
    .default('default'),
})

// ProgressBox Options
export const ProgressBoxOptions = z.object({
  title: z.string().default(''),
  metric: z.string().default(''),
  component: z
    .enum(['', 'actual', 'target', 'percent', 'score'])
    .default('actual'),
  statistic: z
    .enum(['', 'value', 'value_ytd', 'rank', 'team_rank'])
    .default('value'),
  format: z
    .enum(['default', 'ordinal', 'currency', 'percent'])
    .default('default'),
})

// Container Options
export const ContainerOptions = z.object({
  direction: z.enum(['horizontal', 'vertical']).default('horizontal'),
})

// PeriodContainer Options
export const PeriodContainerOptions = z.object({
  periodFilter: z.boolean().default(false),
})

// MetricFilterContainer Options
export const MetricFilterContainerOptions = z.object({
  showMetricFilter: z.boolean().default(true),
  showComponentFilter: z.boolean().default(true),
  showStatisticFilter: z.boolean().default(true),
})

// KpiList Options
export const KpiListOptions = z.object({
  title: z.string().default('KPIs'),
  showOnlyKpis: z.boolean().default(true),
  useShortNames: z.boolean().default(false),
})

// WaterfallChart Options
export const WaterfallChartOptions = z.object({
  title: z.string().default(''),
  metric: z.string().default(''),
})

// BarChart Options
export const BarChartOptions = z.object({
  title: z.string().default(''),
  metric: z.string().default(''),
})

// LineChart Options
export const LineChartOptions = z.object({
  title: z.string().default(''),
  metric: z.string().default(''),
  component: z.enum(['', 'actual', 'target', 'percent', 'score']).default(''),
  statistic: z
    .enum(['', 'value', 'value_ytd', 'rank', 'team_rank'])
    .default(''),
  format: z
    .enum(['default', 'ordinal', 'percent', 'kmsuffix'])
    .default('default'),
})

// KpiTabsContainer Options
export const KpiTabsContainerOptions = z.object({
  direction: z.enum(['horizontal', 'vertical']).default('horizontal'),
})

// PeriodTable Options
export const PeriodTableOptions = z.object({
  columns: z
    .array(
      z.object({
        metric: z.string(),
        component: z.string(),
        statistic: z.string(),
        title: z.string(),
      })
    )
    .default([]),
})
